<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene4',
  mixins: [ SceneMixin ],

  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      this.$els[index]['container'].removeChild(sp)
    })
    this.$scene.filters = null
    this.$container.removeChild(this.$scene)
  },

  created() {

    const sprites = {}
    this.$sprites = sprites
    this.$els = {}

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.$container.addChild(this.$scene)
    this.setCenterContainer(this.$scene)
    this.$parent.$scene4 = this.$scene

    const tempo = .2
    const nb = 5
    const merge = []
    let tls = {}
    let buddy = {}

    for(var i=nb; i>=1; i--) {

      buddy[i] = new Sprite()
      buddy[i].x = 8
      buddy[i].y = 170
      buddy[i].anchor.set(.5, 1)
      buddy[i].scale.set(0.10)
      this.$scene.addChild(buddy[i])
    }

    for(var i=1; i<= nb; i++) {

      tls[i] = new TimelineMax({ delay: 3 *(i-1),  })
      tls[i+'1'] = new TimelineMax()
      tls[i+'2'] = new TimelineMax()
      tls[i+'3'] = new TimelineMax()

      tls[i].add([ tls[i+'1'], tls[i+'2'], tls[i+'3'] ])
      merge.push(tls[i])

      for(var u=1; u< 5; u++) {
        const el = { container: buddy[i], alpha: 0 }
        const name = 'step'+ i + ''+ u
        // const sprite = new Sprite.from(require('./img/'+ folder +'/'+ this.$root.$optimize +'/step'+ u +'.png'))
        const sprite = new Sprite.from(this.$resources['step'+ u].texture) 
              sprite.scale.set(this.$root.$scale*.85)
              sprite.anchor.set(.5, 1)
              sprite.alpha = el.alpha
        el.container.addChild(sprite)
        sprites[name] = sprite
        this.applySettings(sprite, el)
        this.$els[name] = el
      }
    }

    const alphaFilter = new PIXI.filters.AlphaFilter(0)
    this.$scene.filters = [ alphaFilter ]

    _.each(buddy,(budy, index)=>{

      let coef = .1
      for(var i=0; i<=20; i++) {
        tls[index+'1']
          .call(()=>{ this.showStep(sprites, 'step'+ index, 1, tempo) })
          .set({}, { delay: tempo*2*coef })
          .call(()=>{ this.showStep(sprites, 'step'+ index, 2, tempo) })
          .set({}, { delay: tempo*2*coef })
          .call(()=>{ this.showStep(sprites, 'step'+ index, 3, tempo) })
          .set({}, { delay: tempo*2*coef })
          .call(()=>{ this.showStep(sprites, 'step'+ index, 4, tempo) })
          .set({}, { delay: tempo*2*coef })
        coef += .02
      }

      const px = (index%2 === 0) ? -40 : 40
      const py = (index%2 === 0) ? 500 : 500

      tls[index+'2']
        .to(budy, tls[index+'1'].duration(), { pixi: { scale: 3.00, x: px, y: py }, ease: Linear.easeNone })

      tls[index+'3']
        .set({}, { delay: tls[index+'1'].duration()*0.8 })
        .to(budy, tls[index+'1'].duration()*0.1, { pixi: { alpha: 0 }, ease: Linear.easeNone })
        .set({}, { delay: tls[index+'1'].duration()*0.2 })
    })

    const intro = new TimelineMax()
    merge.push(intro)

    intro
      .to(alphaFilter, 5, { alpha: 1, ease: Linear.easeNone })
      // .to(alphaFilter, tls['11'].duration()*0.20, { alpha: 1, ease: Linear.easeNone })
      // .to(sprites['foreground'], tls['11'].duration()*0.10, { pixi: { alpha: 1 }, ease: Linear.easeNone }, '+='+ tls['101'].duration()*2.2 )

    this.$tl.add([ merge ], 44)
     
  },
  mounted() {

    // console.log('Scene4');
    // console.log(this.$resources);
    // this.chapter.$tl.play(45)
  },

  methods: {
    showStep(sprites, ref, step, tempo) {
      for(var i=1; i<5; i++) {
        const sprite = sprites[ref+''+String(i)]
        if(i === step) TweenMax.set(sprite, { pixi:{ alpha: 0.85 }})
        else TweenMax.set(sprite, { pixi:{ alpha: 0 }})
      }
    },
  }

}
</script>





























